(function () {
  'use strict';

  if (customElements.get('sc-product-description-tabs')) return;

  var selectors = {
    source: '[data-sc-description-source]',
    tab: '[data-sc-tab-index]',
    panel: '.sc-product-description-tabs__panel',
  };

  class ScProductDescriptionTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.scTabsInitialized === 'true') return;
      this.dataset.scTabsInitialized = 'true';

      var source = this.querySelector(selectors.source);
      if (!source) return;

      var nodes = Array.prototype.slice.call(source.childNodes);
      var sections = [];
      var intro = [];
      var current = null;

      nodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H6') {
          if (current) sections.push(current);
          current = { title: node.textContent.replace(/\s+/g, ' ').trim(), nodes: [] };
          return;
        }

        if (current) {
          current.nodes.push(node);
        } else {
          intro.push(node);
        }
      });

      if (current) sections.push(current);

      if (sections.length === 0) {
        this.classList.add('sc-product-description-tabs--plain');
        source.hidden = false;
        source.removeAttribute('data-sc-description-source');
        source.classList.remove('sc-product-description-tabs__source');
        return;
      }

      var uid = this.dataset.scTabsId || 'sc-desc';
      var fragment = document.createDocumentFragment();

      if (intro.length > 0) {
        var introEl = document.createElement('div');
        introEl.className = 'sc-product-description-tabs__intro rte';
        intro.forEach(function (node) {
          introEl.appendChild(node);
        });
        fragment.appendChild(introEl);
      }

      var nav = document.createElement('div');
      nav.className = 'sc-product-description-tabs__nav';
      nav.setAttribute('role', 'tablist');

      var panels = document.createElement('div');
      panels.className = 'sc-product-description-tabs__panels';

      sections.forEach(function (section, index) {
        var tabId = uid + '-tab-' + index;
        var panelId = uid + '-panel-' + index;
        var isActive = index === 0;

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sc-product-description-tabs__tab' + (isActive ? ' is-active' : '');
        button.setAttribute('role', 'tab');
        button.id = tabId;
        button.setAttribute('aria-controls', panelId);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
        button.textContent = section.title;
        button.dataset.scTabIndex = String(index);

        var panel = document.createElement('div');
        panel.className = 'sc-product-description-tabs__panel rte' + (isActive ? ' is-active' : '');
        panel.setAttribute('role', 'tabpanel');
        panel.id = panelId;
        panel.setAttribute('aria-labelledby', tabId);
        panel.hidden = !isActive;
        section.nodes.forEach(function (node) {
          panel.appendChild(node);
        });

        nav.appendChild(button);
        panels.appendChild(panel);
      });

      source.remove();
      fragment.appendChild(nav);
      fragment.appendChild(panels);
      this.appendChild(fragment);

      nav.addEventListener('click', this.onTabClick.bind(this));
      nav.addEventListener('keydown', this.onTabKeydown.bind(this));
    }

    onTabClick(event) {
      var button = event.target.closest(selectors.tab);
      if (!button || button.classList.contains('is-active')) return;
      this.activateTab(parseInt(button.dataset.scTabIndex, 10));
    }

    onTabKeydown(event) {
      var tabs = Array.prototype.slice.call(this.querySelectorAll(selectors.tab));
      var currentIndex = tabs.findIndex(function (tab) {
        return tab === document.activeElement;
      });

      if (currentIndex === -1) return;

      var nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.activateTab(nextIndex);
      tabs[nextIndex].focus();
    }

    activateTab(index) {
      var tabs = this.querySelectorAll(selectors.tab);
      var panels = this.querySelectorAll(selectors.panel);

      tabs.forEach(function (tab, tabIndex) {
        var isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel, panelIndex) {
        var isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }
  }

  customElements.define('sc-product-description-tabs', ScProductDescriptionTabs);
})();
